export default {
    admin_base_url: 'https://login.htaq.net/admin/rpc',
    admin_upload_url: 'https://login.htaq.net/admin/rpc',
    applet_base_url: 'https://login.htaq.net/applet/rpc',
    applet_upload_url: 'https://login.htaq.net/applet/rpc',
}